import React, { Component, PropTypes } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

import fileDownload from 'react-file-download';


export default class Donate extends Component {
  constructor(props) {
    super(props)
    this.download = this.download.bind(this)
  }

  download(file) {
    // fileDownload("../../assets/files/formular230.pdf", 'filename.pdf');
    
    // fake server request, getting the file url as response
    setTimeout(() => {
      const response = {
        file: file,
      };
      // server sent the url to the file!
      // now, let's download:
      window.open(response.file);
      // you could also do:
      // window.location.href = response.file;
    }, 100);
  }
  makeFile() {
    // do some calculations

    fileDownload("../../assets/files/formular230.pdf", 'formular230.pdf');
    return {
      mime: 'application/pdf',
      filename: '../../assets/files/formular230.pdf',
    }
  }
  render() {

    return (
      <div className="col-sm-12">
        <h3>Cum donam? - Donaţii şi sponsorizări</h3>
        <section className="category cc-articles">

          <div className="i" id="articles">
            {/* <h2 className="category__title category__title--lozenge"><span className="category__title__text">Centrul de recuperare</span></h2> */}
            <div className="item item--issue item--link">
              <p className="text-justify">
                - Persoanele fizice care doresc să sprijine activitatea asociaţiei pot face donaţii personale ȋn conturile asociaţiei.<br />
                - De asemenea, prin depunerea Formularului 230 puteţi redirecţiona  procentul de 2% din impozitul anual pe salariu. Declaratia se depune la sediul fiscal din localitatea de domiciliu a declarantului.<br />
                - Formular 230 <a href="../../assets/files/formular230.pdf" download ="formular230.pdf"> Descarcă</a> <br />
                - Persoanele juridice pot face sponsorizări ȋn limitele legii ȋn baza contractului de sponsorizare.<br />
                - Contract de sponsorizare.<a href = "../../assets/files/contract_sponsorizare.pdf" download="contract_sponsorizare.pdf" >Descarcă</a> <br />
              </p>

              <h3>Conturile bancare: </h3>
              <h4>Cont Euro: RO97BTRLEURCRT0282041001</h4>
              <h4>Cont RON:  RO50BTRLRONCRT0282041001</h4>
              <h4>Titular cont: Asociatia Umanitara "Dreptul la viata" Huedin</h4>

            </div>
          </div>
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/Donate/donate.js